import { forEach, toggleClass } from '../functions';

function getRandomInt(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

export default function sliders() {
  var carousels = document.querySelectorAll('.carousel');
  forEach(carousels, (index, carousel) => {
    var id = carousel.getAttribute('data-target');
    var slider = tns({
      container: '#' + id,
      items: 1,
      startIndex: getRandomInt(3),
      slideBy: 'page',
      autoplay: false,
      navContainer: '.thumbs-' + id,
      navAsThumbnails: true,
      mouseDrag: true
    });
    var thumbnails = carousel.querySelectorAll('.carousel-thumb');
    forEach(thumbnails, (index, thumbnail) => {
      thumbnail.addEventListener('click', (event) => {
        event.preventDefault();
        var slideNumber = parseInt(thumbnail.getAttribute('data-slide-number'));
        slider.goTo(slideNumber);
      });
    })
  });
}
